import {HttpParams} from "@angular/common/http";

/**
 * Converts a set of key/value pairs into an HttpParams object.
 *
 * If `params` is an array of objects, each object should have the properties `name` and `val`.
 * If `params` is an object, its keys and values are used directly.
 *
 * By default, only keys with non-null values are included.
 *
 * @param params Either an array of objects with {name, val} or a plain object with key/value pairs.
 * @param includeNulls Optional flag. If true, keys with null values are included (with their value converted to an empty string).
 *                     Defaults to false.
 * @returns An HttpParams object containing the provided keys/values.
 */
export function toRequestParams(params: any, includeNulls: boolean = false): HttpParams {
  let requestParams = new HttpParams();

  if (params) {
    if (Array.isArray(params)) {
      // When params is an array of objects.
      params.filter((f: any) => includeNulls ? true : f.val !== null)
        .forEach((ea: any) => {
          requestParams = requestParams.append(ea.name, ea.val);
        });
    } else if (typeof params === 'object') {
      // When params is a plain object.
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (includeNulls || val !== null) {
          requestParams = requestParams.append(key, val);
        }
      });
    }
  }

  return requestParams;
}


export function openLinkInNewTab(link: string): void {
  window.open(sanitiseUrl(link), '_blank', 'noopener noreferrer');
}

export function sanitiseUrl(url?: string): string {

  if (!url) {
    return '//invalid-url';
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return '//' + url;
}

export function copyToClipboard(text: string): void {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(err => {
      console.error('Failed to copy to clipboard:', err);
    });
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
  }
}
